import { identify, makeRequest, Service } from '../../../utils/http';

export async function getRunningDocumentsForUserApi() {
  return makeRequest(Service.getRunningDocumentsForUser(await identify()));
}
